import React from 'react';
import { PortalOverlay, Pane, Dialog, Flex, Content, Button, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './Upsell.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('r4k.views.upsell');
export default class Upsell extends React.Component {
  contactRedirect = () => {
    window.open(t('keyContact'), '_blank');
  };
  videoRedirect = () => {
    window.open(t('video'), '_blank');
  };
  render() {
    const {
      show,
      onClose,
      mobile
    } = this.props;
    return /*#__PURE__*/_jsx(PortalOverlay, {
      variant: "dialog",
      showBackground: true,
      escapeWillClose: false,
      clickWillClose: false,
      show: show,
      onClose: onClose,
      targetId: "fullScreen",
      animation: "slideFromBottom",
      position: mobile ? 'full' : 'center',
      children: /*#__PURE__*/_jsxs(Dialog, {
        show: show,
        onClose: onClose,
        className: S.dialog,
        children: [/*#__PURE__*/_jsxs(Pane, {
          className: S.pane,
          children: [/*#__PURE__*/_jsx(Flex, {
            variant: "row",
            children: /*#__PURE__*/_jsx(Text, {
              className: S.pill,
              variant: "pillSuccess",
              children: t('newProduct')
            })
          }), /*#__PURE__*/_jsx(Flex, {
            variant: "row",
            children: /*#__PURE__*/_jsx("img", {
              className: S.image,
              alt: "recovr for keys",
              src: "https://storage.googleapis.com/recovr-ui-assets/keys_upgrade.svg"
            })
          }), /*#__PURE__*/_jsx(Flex, {
            variant: "row",
            align: "start",
            children: /*#__PURE__*/_jsx(Text, {
              className: S.title,
              children: t('title')
            })
          }), /*#__PURE__*/_jsx(Flex, {
            variant: "row",
            align: "start",
            children: /*#__PURE__*/_jsx(Text, {
              className: S.bodyText,
              children: t('info')
            })
          })]
        }), /*#__PURE__*/_jsxs(Content.Footer, {
          variant: "dialogFooter",
          layout: "flex:rowMEnd",
          className: S.footer,
          children: [/*#__PURE__*/_jsxs(Button, {
            variant: "secondary",
            onClick: this.videoRedirect,
            children: [" ", t('watch')]
          }), /*#__PURE__*/_jsxs(Button, {
            variant: "primary",
            onClick: this.contactRedirect,
            children: [" ", t('contact')]
          })]
        })]
      })
    });
  }
}